import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.6;
const DEFAULT_HEIGHT = 0.8;
const WALL_GAP_M = 0.1;

const Desk: C1_FurnitureDefinition = {
  category: RoomType.Office,
  id: "desk",

  icon: <C1_FurnitureIcon kind="desk" />,

  description: {
    en: "Desk",
    de: "Schreibtisch",
  },

  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  grabsW: true,
  grabsH: true,
  originXPercentage: 50,
  originYPercentage: 0,

  properties: [],

  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const geometryOffsetY = WALL_GAP_M * PX;
    const inset = 0.02 * PX;
    const monitorWidth = Math.min(0.5 * PX, width * 0.5);
    const monitorDepth = Math.min(0.06 * PX, height * 0.12);
    const chairWidth = Math.min(0.4 * PX, width * 0.4);
    const chairDepth = 0.16 * PX;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={50}
        originYPercentage={0}
      >
        <g transform={`translate(0 ${geometryOffsetY})`}>
          <rect
            x={inset}
            y={inset}
            width={Math.max(0, width - inset * 2)}
            height={Math.max(0, height - inset * 2)}
            rx={inset}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          {showDetails && (
            <>
              <rect
                x={width / 2 - monitorWidth / 2}
                y={height * 0.2}
                width={monitorWidth}
                height={monitorDepth}
                rx={Math.min(inset, monitorDepth / 2)}
                fill={finalFillColor}
                stroke={finalStrokeColor}
                strokeWidth={finalStrokeWidth}
              />
              <rect
                x={width / 2 - chairWidth / 2}
                y={height + 0.04 * PX}
                width={chairWidth}
                height={chairDepth}
                rx={Math.min(0.04 * PX, chairDepth / 2)}
                fill={finalFillColor}
                stroke={finalStrokeColor}
                strokeWidth={finalStrokeWidth}
              />
            </>
          )}
        </g>
      </C1_FurnitureSvg>
    );
  },
};

export default Desk;
